export const Auditorium = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="5" y="3" width="22" height="10" rx="1" stroke="currentColor" stroke-width="2"/>
<path d="M9 30V27C9 26.4477 8.55228 26 8 26H4C3.44772 26 3 26.4477 3 27V30" stroke="currentColor" stroke-width="2"/>
<path d="M19 30V27C19 26.4477 18.5523 26 18 26H14C13.4477 26 13 26.4477 13 27V30" stroke="currentColor" stroke-width="2"/>
<path d="M29 30V27C29 26.4477 28.5523 26 28 26H24C23.4477 26 23 26.4477 23 27V30" stroke="currentColor" stroke-width="2"/>
<circle cx="6" cy="22" r="1.5" fill="currentColor" stroke="currentColor"/>
<circle cx="16" cy="22" r="1.5" fill="currentColor" stroke="currentColor"/>
<circle cx="26" cy="22" r="1.5" fill="currentColor" stroke="currentColor"/>
<circle cx="21" cy="18" r="1.5" fill="currentColor" stroke="currentColor"/>
<circle cx="11" cy="18" r="1.5" fill="currentColor" stroke="currentColor"/>
</svg>`;
